export default {
  surchargeManagement: {
    // 页面标题
    title: '附加费维护',
    description: '管理各类附加费信息',

    // 标签页导航
    tabs: {
      fcl: '整箱附加费',
      lcl: '拼箱附加费',
      air: '空运附加费',
      prePort: '港前附加费',
      lastMile: '尾程附加费',
      express: '快递附加费',
      rail: '铁路附加费'
    },

    rail: {
      filters: {
        code: '编码',
        railCompany: '铁路公司',
        supplier: '供应商',
        pol: '起运站',
        pod: '目的站',
        exitPort: '出境口岸',
        entryPort: '入境口岸',
        company: '所属公司',
        cargoType: '货物类型',
        validPeriod: '有效期',
        status: '状态'
      },
      placeholders: {
        batchCode: '支持批量查询',
        select: '请选择',
        selectRailCompany: '请选择铁路公司',
        selectSupplier: '请选择供应商',
        selectPol: '请选择起运站',
        selectPod: '请选择目的站',
        selectExitPort: '请选择出境口岸',
        selectEntryPort: '请选择入境口岸',
        selectCompany: '请选择所属公司',
        selectCargoType: '请选择货物类型',
        selectStatus: '请选择状态',
        startDate: '开始日期',
        endDate: '结束日期',
        all: '全部'
      },
      actions: {
        search: '查询',
        reset: '重置',
        add: '新建',
        import: '导入',
        export: '导出',
        batchEnable: '批量启用',
        batchDisable: '批量禁用',
        view: '详情',
        edit: '编辑',
        copy: '复制',
        delete: '删除',
        more: '更多',
        enable: '启用',
        disable: '禁用'
      },
      columns: {
        code: '编码',
        priority: '优先级',
        railCompany: '铁路公司',
        supplier: '供应商',
        pol: '起运站',
        pod: '目的站',
        exitPort: '出境口岸',
        entryPort: '入境口岸',
        company: '所属公司',
        cargoType: '货物类型',
        feeItems: '费用项',
        validPeriod: '有效期',
        status: '状态',
        actions: '操作'
      },
      status: {
        enabled: '启用',
        disabled: '禁用',
        expired: '失效'
      },
      messages: {
        priorityTip: '1-99，数字越大优先级越高；默认1',
        loadFailed: '获取铁路附加费失败',
        copied: '已复制附加费信息，请确认后保存',
        confirmActionTitle: '确认{action}',
        confirmActionContent: '确定要{action}该附加费吗？',
        actionSuccess: '已{action}',
        confirmDeleteTitle: '确认删除',
        confirmDeleteContent: '删除后不可恢复，确定要删除该附加费吗？',
        deleteSuccess: '删除成功',
        selectSurcharge: '请选择铁路附加费',
        batchEnableTitle: '批量启用',
        batchDisableTitle: '批量禁用',
        batchEnableContent: '确定要启用选中的 {count} 条记录吗？',
        batchDisableContent: '确定要禁用选中的 {count} 条记录吗？',
        batchEnableSuccess: '已启用 {count} 条记录',
        batchDisableSuccess: '已禁用 {count} 条记录',
        feeItemCount: '{count}项',
        confirmExportTitle: '确认导出',
        confirmExportSelected: '将导出已勾选的 {count} 条铁路附加费，导出任务将在后台执行，完成后可在任务中心下载。',
        confirmExportAll: '将按当前查询条件导出铁路附加费，导出任务将在后台执行，完成后可在任务中心下载。',
        exportSubmitFailed: '导出任务提交失败',
        exportSubmitted: '导出任务已提交',
        exportFailed: '导出失败',
        goTaskCenterTitle: '跳转任务中心',
        goTaskCenterContent: '是否前往任务中心查看导出进度？',
        goTaskCenterOk: '前往任务中心',
        confirm: '确认',
        cancel: '取消',
        dash: '—'
      },
      import: {
        title: '导入铁路附加费',
        template: '模板',
        downloadTemplate: '下载铁路附加费模板',
        instructionTitle: '导入说明',
        instruction1: '1. 支持 .xlsx / .xls 文件，大小不超过 5MB。',
        instruction2: '2. 基础数据字段可以填写 ID，也可以填写可搜索到的名称或编码。',
        instruction3: '3. 同一组基础匹配字段下的多行费用明细会合并为同一条铁路附加费。',
        instruction4: '4. 导入结果和失败行原因请到任务管理查看。',
        uploadText: '点击或拖拽文件到这里',
        uploadHint: '支持 .xlsx / .xls',
        reselect: '重新选择',
        cancel: '取消',
        startImport: '开始导入',
        fileTypeError: '只支持 .xlsx / .xls 文件',
        fileSizeError: '文件大小不能超过 5MB',
        downloadFailed: '模板下载失败',
        taskCreated: '导入任务已创建，请在任务管理查看处理结果',
        taskCreateFailed: '导入任务创建失败'
      },
      detail: {
        copyAlert: '已复制原附加费信息，编码将重新生成，请确认信息后保存。',
        matchConditionTitle: '匹配条件（自动匹配运价）',
        matchConditionTip: '运价保存/编辑时，自动检索满足以下所有条件的附加费标准并带入运价。选填字段未填写时匹配所有运价',
        code: '编码：',
        autoGenerate: '系统自动生成',
        contractNo: '约号',
        validPeriod: '有效期',
        startDate: '开始日期',
        endDate: '结束日期',
        entryPort: '入境境外对应口岸',
        originCity: '起运城市',
        destinationCity: '目的城市',
        originCountry: '起运国',
        destinationCountry: '目的国',
        containerOwner: '箱属',
        directTransit: '直达/中转',
        hsCode: 'HS编码',
        priority: '优先级',
        feeDetailTitle: '费用明细',
        feeName: '费用名称',
        unit: '单位',
        currency: '币种',
        addFeeItem: '添加费用项',
        createTitle: '新增铁路附加费',
        copyTitle: '复制铁路附加费',
        editTitle: '编辑铁路附加费',
        viewTitle: '铁路附加费详情',
        includeInTotal: '是否参与总价计算',
        alreadyIncluded: '是否已包含',
        paymentTerm: '付费条款',
        unitPrice: '单价',
        boxTypeSetting: '箱型设置',
        boxTypeUpdated: '箱型设置已更新',
        unitRequired: '第 {row} 行请选择单位',
        currencyRequired: '第 {row} 行请选择币种',
        unitPriceRequired: '第 {row} 行请填写单价',
        containerPriceRequired: '第 {row} 行单位为「箱」时，请至少填写一个箱型价格',
        yes: '是',
        no: '否',
        prepaid: '预付',
        collect: '到付',
        prepaidCollect: '预付/到付',
        input: '请输入',
        defaultPriority: '默认1',
        optionalMatchAll: '不选则匹配所有',
        emptyMatchAll: '不填则匹配所有',
        selectFeeName: '请选择费用名称',
        keepOneFeeItem: '至少需要保留一个费用项',
        copied: '已复制附加费信息，编码将重新生成',
        requiredWarning: '请检查必填项',
        companyRequired: '请选择所属公司',
        validPeriodRequired: '请选择有效期',
        railCompanyRequired: '请选择铁路公司',
        exitPortRequired: '请选择出境口岸',
        priorityRequired: '请输入优先级',
        feeItemRequired: '请至少维护一条费用明细',
        feeNameRequired: '请选择费用名称',
        updateSuccess: '附加费更新成功！',
        createSuccess: '附加费创建成功！',
        saveFailed: '保存失败，请重试',
        back: '返回',
        save: '保存'
      }
    },

    // 表格列
    columns: {
      feeNo: '附加费ID',
      feeStatus: '费用状态',
      feeItems: '费用项',
      pol: '起运港',
      pols: '起运港',
      polTerminalIds: '起运港码头',
      carrier: '船公司',
      carrierIds: '船公司',
      supplierIds: '供应商',
      pods: '卸货港',
      podTerminalIds: '卸货港码头',
      podRouteCategorys: '卸货港航线分类',
      polRouteCategorys: '起运港航线分类',
      pors: '收货地',
      pdls: '目的港',
      transferPorts: '中转港',
      officeIds: '所属公司',
      contractNos: '约号',
      nacs: 'NAC',
      cargoTypes: '货物类型',
      unitRate: '费用(票)',
      lane: '航线',
      validPeriod: '有效期',
      createdBy: '创建人',
      modifiedBy: '修改人',
      dateCreated: '创建时间',
      dateModified: '修改时间',
      actions: '操作',
      chargingItems: '费用项'
    },

    // 查询条件字段标签
    filterLabels: {
      feeNo: '费用ID',
      feeStatus: '费用状态',
      portGroup: '港口组',
      pol: '起运港',
      carrier: '船公司',
      airline: '航空公司',
      lane: '航线',
      validPeriod: '有效期',
      beginDate: '生效日期',
      endDate: '失效日期',
      createdBy: '创建人',
      dateCreated: '创建时间',
      modifiedBy: '修改人',
      dateModified: '修改时间'
    },

    statusEnum: {
      1: '禁用',
      2: '启用',
      3: '过期',
      4: '禁用',
      6: '待导入'
    },

    inquiryEnum: {
      1: '海运费',
      2: '起运港费用',
      3: '卸货港费用',
      4: '潜在费用'
    },

    fcl: {
      import: {
        title: '导入整箱附加费',
        templateSection: '模板下载',
        templateDesc: '请先下载标准导入模板，按模板格式填写数据后上传',
        downloadTemplate: '整箱附加费导入模板.xlsx',
        uploadSection: '文件上传',
        dragText: '拖拽文件到此处，或点击上传',
        dragHint: '支持 .xlsx / .xls 格式，最大 5MB，可包含多个Sheet',
        remove: '移除',
        autoFillTitle: '自动填充说明',
        autoFillOffice: '所属公司：导入时自动获取您的所属公司',
        autoFillStatus: '状态：导入后根据有效期自动判断（当前日期 ≤ 有效期截止 → 启用；否则 → 失效）',
        autoFillUnit: '费用单位：支持 箱、票、天、次、重量(KGS)、立方米(CBM)、吨(TEN)、计费吨(RT)',
        autoFillUnitSimple: '费用单位：支持 箱、票',
        autoFillBoxPrice: '箱型价格：单位为「箱」时，任一箱型存在价格即可',
        autoFillUnitPrice: '单价：单位非「箱」时必填',
        autoFillInTotal: '是否计入总价：默认为「否」',
        autoFillIncluded: '总价是否已包含：默认为「否」',
        cancel: '取消',
        startValidate: '开始校验',
        validating: '校验中...',
        fileSizeError: '文件大小不能超过 5MB',
        fileTypeError: '请上传 Excel 文件（.xlsx 或 .xls）',
        uploadSuccess: '上传成功，解析任务已提交',
        uploadFailed: '上传失败，请重试',
        downloadSuccess: '模板下载成功',
        downloadFailed: '下载模板失败'
      },

      // 页面标题
      title: '整箱附加费管理',
      description: '管理整箱附加费信息',

      // 操作按钮
      actions: {
        add: '新增整箱附加费',
        addOceanFreight: '新增海运附加费',
        addPol: '新增起运港费用',
        addPod: '新增卸货港费用',
        import: '导入',
        batchOperations: '批量操作',
        batchEnable: '批量启用',
        batchDisable: '批量禁用',
        batchDelete: '批量删除',
        view: '详情',
        edit: '编辑',
        more: '更多',
        copy: '复制',
        enable: '启用',
        disable: '禁用',
        delete: '删除'
      },

      // 批量操作
      batch: {
        selected: '已选择 {count} 项',
        enableConfirm: '确定要将选中的 {count} 条附加费启用吗？',
        disableConfirm: '确定要将选中的 {count} 条附加费禁用吗？',
        deleteConfirm: '确定要删除选中的 {count} 条附加费吗？此操作不可恢复。',
        enableSuccess: '成功启用 {count} 条附加费',
        disableSuccess: '成功禁用 {count} 条附加费',
        deleteSuccess: '成功删除 {count} 条附加费'
      },

      // 消息提示
      messages: {
        enableSuccess: '启用成功',
        enableFailed: '启用失败',
        disableSuccess: '禁用成功',
        disableFailed: '禁用失败',
        batchEnableSuccess: '批量启用成功',
        batchEnableFailed: '批量启用失败',
        batchDisableSuccess: '批量禁用成功',
        batchDisableFailed: '批量禁用失败',
        deleteSuccess: '删除成功',
        deleteFailed: '删除失败',
        statusSwitchFailed: '状态切换失败，请重试',
        onlyDraftCanEnable: '只有草稿状态的附加费才能上架，当前选中包含：{status} 状态的附加费',
        exportFilename: '整箱附加费导出.xlsx',
        exportFilenamePrefix: '整箱附加费导出',
        exportSuccess: '导出成功',
        exportFailed: '导出失败',
        onlyNormalCanDisable: '只有正常状态的附加费才能下架，当前选中包含：{status} 状态的附加费',
        importFeature: '导入功能开发中',
        aiRecognitionDemo: 'AI识别功能演示',
        missingRecordId: '无法查看详情：缺少记录ID',
        missingEditId: '无法编辑：缺少记录ID',
        loadDataFailed: '加载数据失败',
        statusOperationNotAllowed: '{status}状态的附加费不能进行启用/禁用操作',
        copyDataFailed: '复制数据加载失败',
        draftSaveSuccess: '草稿保存成功',
        draftSaveFailed: '保存草稿失败',
        unknown: '未知错误',
        noBaseFeeData: '未获取到基础费用',
        saveDataFirst: '请先保存数据',
        atLeastOneRateItem: '至少需要保留一个运价项目',
        containerSettingsUpdated: '箱型设置已更新',
        aiRecognitionSuccess: 'AI识别完成，已自动填充运价信息！',
        atLeastOneContainerType: '计费单位为"箱"时，至少需要填写一个箱型价格（第{row}行）',
        unitRateRequired: '计费单位为"票"时，单价必填（第{row}行）',
        billingUnitRequired: '计费单位必填（第{row}行）',
        currencyRequired: '币种必填（第{row}行）',
        isTotalIncludedRequired: '总价是否已包含必填（第{row}行）',
        isCountTotalRequired: '是否计入总价必填（第{row}行）',
        feeItemRequired: '费用名称必填（第{row}行）',
        conflictTitle: '有效期冲突',
        conflictTip: '当前附加费与 {feeNos} 的有效期存在冲突，是否确认覆盖保存？',
        confirmOverride: '确认覆盖'
      },

      // 详情页面
      detail: {
        // 页面标题
        createTitle: '新增整箱附加费',
        editTitle: '编辑整箱附加费',
        viewTitle: '附加费详情',
        copyTitle: '复制整箱附加费',
        createTitleOceanFreight: '新增海运附加费',
        editTitleOceanFreight: '编辑海运附加费',
        viewTitleOceanFreight: '海运附加费详情',
        copyTitleOceanFreight: '复制海运附加费',
        createTitleOceanFreightLcl: '新建拼箱海运附加费',
        editTitleOceanFreightLcl: '编辑拼箱海运附加费',
        viewTitleOceanFreightLcl: '拼箱海运附加费详情',
        copyTitleOceanFreightLcl: '复制拼箱海运附加费',
        createTitleAir: '新增空运附加费',
        editTitleAir: '编辑空运附加费',
        viewTitleAir: '空运附加费详情',
        copyTitleAir: '复制空运附加费',
        createTitlePol: '新增起运港费用',
        editTitlePol: '编辑起运港费用',
        viewTitlePol: '起运港费用详情',
        copyTitlePol: '复制起运港费用',
        createTitlePolLcl: '新建拼箱起运港费用',
        editTitlePolLcl: '编辑拼箱起运港费用',
        viewTitlePolLcl: '拼箱起运港费用详情',
        copyTitlePolLcl: '复制拼箱起运港费用',
        createTitlePod: '新增卸货港费用',
        editTitlePod: '编辑卸货港费用',
        viewTitlePod: '卸货港费用详情',
        copyTitlePod: '复制卸货港费用',
        createTitlePodLcl: '新建拼箱卸货港费用',
        editTitlePodLcl: '编辑拼箱卸货港费用',
        viewTitlePodLcl: '拼箱卸货港费用详情',
        copyTitlePodLcl: '复制拼箱卸货港费用',

        // 基础信息
        basicInfo: '基本信息',
        pol: '起运港',
        polTerminal: '起运港码头',
        carrier: '船公司',
        feeStatus: '费用状态',
        lane: '航线',
        validPeriod: '有效期',
        beginDate: '开始日期',
        endDate: '结束日期',
        supplier: '供应商',
        pod: '卸货港',
        podTerminal: '卸货港码头',
        podRouteCategory: '卸货港航线分类',
        polRouteCategory: '起运港航线分类',
        pors: '收货地',
        pdls: '目的港',
        transferPorts: '中转港',
        office: '所属公司',
        contractNo: '约号',
        cargoType: '货物类型',
        priority: '优先级',
        priorityTooltip: '数值越大优先执行',
        yes: '是',
        no: '否',

        // 付费条款
        paymentTypes: {
          prepaid: '预付',
          collect: '到付',
          prepaidOrCollect: '预付/到付'
        },

        // 运价明细
        priceDetails: '运价明细',
        feeDetails: '费用明细',
        feeDetailsTipPol: '同一记录内费用名称不可重复；单位=票时费用必填，单位=箱时箱型价格必填',
        feeDetailsTipPod: '单位=票时费用(票)必填；单位=箱时各箱型价格必填（支持动态添加箱型）',
        byContainerType: '按箱型计费',
        notByContainerType: '非按箱型计费',
        containerTypeSettings: '箱型设置',
        selectContainerTypes: '请选择需要显示的箱型',
        addItem: '添加项目',
        baseFee: '基础费用',

        // 费用项目
        feeItem: '费用名称',
        autoFill: '自动填充',
        billingUnit: '计费单位',
        unitPrice: '单价',
        specialRemarks: '特殊备注',

        // 表格列
        tableColumns: {
          feeName: '费用名称',
          billingType: '计费类型',
          currency: '币种',
          billingUnit: '计费单位',
          unitPrice: '单价',
          unitRate: '单价',
          specialRemarks: '特殊备注',
          actions: '操作',
          baseFee: '基础费用',
          isTotalIncluded: '总价是否已包含',
          isCountTotal: '是否计入总价',
          paymentType: '付费条款'
        },

        // 操作按钮
        operationButtons: {
          addItem: '添加项目',
          delete: '删除'
        },

        // 计费类型
        billingTypes: {
          byContainerType: '按箱型计费',
          notByContainerType: '非按箱型计费'
        },

        // AI识别
        aiRecognition: 'AI智能识别',
        uploadFile: '上传运价文件',
        dragAndDrop: '点击或拖拽文件到此区域上传',
        supportedFormats: '支持格式：PDF、Excel、Word、图片等',
        selectFile: '选择文件',
        aiDescription: 'AI识别说明',
        aiFeatures: [
          '• AI将自动识别运价表格中的港口、船公司、价格等信息',
          '• 支持多种文件格式 and 复杂表格结构',
          '• 识别完成后会自动填充到对应字段中',
          '• 请确保上传的文件清晰可读'
        ],

        // 复制提示
        copyTip: '正在复制运价信息，运价编号将自动重新生成，请确认所有信息后保存',

        // 占位符
        placeholders: {
          selectPol: '请选择起运港',
          selectPolTerminal: '请选择起运港码头',
          selectCarrier: '请选择船公司',
          selectFeeStatus: '请选择费用状态',
          selectPortGroup: '请选择港口组',
          selectLane: '请选择航线',
          selectFeeItem: '请选择费用名称',
          selectBillingType: '请选择计费类型',
          selectBillingUnit: '请选择计费单位',
          enterPrice: '请输入价格',
          enterUnitPrice: '请输入单价',
          enterRemarks: '请输入特殊备注',
          feeNoGenerated: '后端自动生成，格式：73F75AN6',
          feeNoCopy: '复制后将重新生成，格式：73F75AN6',
          selectSupplier: '请选择供应商',
          selectPod: '请选择卸货港',
          selectPodTerminal: '请选择卸货港码头',
          selectPodRouteCategory: '请选择卸货港航线分类',
          selectPolRouteCategory: '请选择起运港航线分类',
          selectPors: '请选择收货地',
          selectPdls: '请选择目的港',
          selectTransferPorts: '请选择中转港',
          selectOffice: '请选择所属公司',
          selectContractNo: '请选择约号',
          selectNac: '请选择NAC',
          selectCargoType: '请选择货物类型',
          enterPriority: '请输入优先级',
          selectCurrency: '请选择币种',
          selectPaymentType: '请选择付费条款',
          enterFeeNo: '请输入费用ID',
          enterCreatedBy: '请输入创建人',
          enterModifiedBy: '请输入修改人',
          selectBeginDate: '请选择生效日期',
          selectEndDate: '请选择失效日期',
          selectDateCreated: '请选择创建时间',
          selectDateModified: '请选择修改时间'
        },

        // 验证消息
        validation: {
          selectPolRequired: '请选择起运港',
          selectPodRequired: '请选择卸货港',
          selectCarrierRequired: '请选择船公司',
          selectFeeStatusRequired: '请选择费用状态',
          selectLaneRequired: '请选择至少一个航线',
          selectValidPeriodRequired: '请选择有效期',
          selectFeeItemRequired: '请选择费用名称',
          selectBillingUnitRequired: '请选择计费单位',
          enterPriceRequired: '请输入价格',
          enterUnitPriceRequired: '请输入单价',
          selectPodRouteCategoryRequired: '请选择卸货港航线分类',
          selectOfficeRequired: '请选择所属公司',
          priorityRequired: '请输入优先级'
        },

        // 状态文本
        status: {
          normal: '启用',
          disabled: '禁用'
        },

        // 按钮
        buttons: {
          back: '返回',
          save: '保存',
          edit: '编辑',
          copy: '复制'
        },

        // 操作消息
        messages: {
          containerSettingsUpdated: '箱型设置已更新',
          atLeastOneRateItem: '至少需要保留一个运价项目',
          aiRecognitionSuccess: 'AI识别完成，已自动填充运价信息！'
        }
      }
    },

    lcl: {
      import: {
        title: '导入海运拼箱附加费',
        templateSection: '模板下载',
        templateDesc: '请先下载标准导入模板，按模板格式填写数据后上传',
        oceanTemplate: '海运附加费模板',
        polTemplate: '起运港费用模板',
        podTemplate: '卸货港费用模板',
        uploadSection: '文件上传',
        dragText: '拖拽文件到此处，或点击上传',
        dragHint: '支持 .xlsx / .xls 格式，最大 5MB，可包含多个Sheet',
        remove: '移除',
        autoFillTitle: '自动填充说明',
        autoFillOffice: '所属公司：导入时自动获取您的所属公司',
        autoFillStatus: '状态：导入后根据有效期自动判断（当前日期 ≤ 有效期截止 → 启用；否则 → 失效）',
        autoFillUnit: '费用单位：支持 箱、票、天、次、重量(KGS)、立方米(CBM)、吨(TEN)、计费吨(RT)',
        autoFillBoxPrice: '箱型价格：单位为「箱」时，任一箱型存在价格即可',
        autoFillUnitPrice: '单价：单位非「箱」时必填',
        autoFillInTotal: '是否计入总价：默认为「否」',
        autoFillIncluded: '总价是否已包含：默认为「否」',
        cancel: '取消',
        startValidate: '开始校验',
        validating: '校验中...',
        validatePass: '校验通过',
        validatePassDesc: '共解析 {success} 条附加费记录，包含 {detail} 条费用明细',
        validatePassSummary: '海运附加费: {ocean} 条 | 起运港费用: {pol} 条 | 卸货港费用: {pod} 条',
        previewTitle: '数据预览（前 10 条）',
        colFeeType: '费用类型',
        colCarrier: '船司',
        colPort: '港口',
        colFeeCount: '费用项',
        colFeeCountSuffix: '{count}项',
        colValidity: '有效期',
        validateFail: '校验完成，发现 {fail} 条错误',
        validateFailDesc: '成功：{success} 条  |  失败：{fail} 条',
        errorTitle: '失败明细',
        colSheet: 'Sheet',
        colRowNo: '行号',
        colFieldName: '错误字段',
        colErrorMsg: '错误原因',
        downloadError: '下载错误报告',
        successPreviewTitle: '成功数据预览（{count} 条）',
        back: '返回修改',
        confirmImport: '确认导入（{count} 条）',
        importing: '正在导入...',
        importedProgress: '已处理：{processed} / {total} 条',
        importSuccess: '导入成功',
        importSuccessDesc: '成功导入 {success} 条附加费记录，包含 {detail} 条费用明细',
        importPartial: '导入完成，部分成功',
        importPartialDesc: '成功导入 {success} 条，失败 {fail} 条',
        importPartialHint: '失败原因已导出至错误报告，可修正后重新导入',
        confirm: '确定',
        fileSizeError: '文件大小不能超过 5MB',
        fileTypeError: '请上传 Excel 文件（.xlsx 或 .xls）',
        uploadSuccess: '上传成功，解析任务已提交',
        uploadFailed: '上传失败，请重试',
        downloadSuccess: '模板下载成功',
        downloadFailed: '下载模板失败',
        generatingReport: '正在生成错误报告 Excel...'
      }
    },

    air: {
      actions: {
        add: '新增空运附加费'
      },
      detail: {
        // 页面标题
        createTitle: '新建空运附加费',
        editTitle: '编辑空运附加费',
        viewTitle: '空运附加费详情',
        copyTitle: '复制空运附加费',

        // 基本信息字段标签
        airline: '航空公司',
        dateType: '日期类型',
        originSection: '起运地（国家-城市-机场 互相筛选）',
        originCountry: '起运国',
        originCity: '起运城市',
        originAirport: '起运机场',
        destSection: '目的地（国家-城市-机场 互相筛选）',
        destCountry: '目的国',
        destCity: '目的城市',
        destAirport: '目的机场',
        iataZone: 'IATA分区（兜底匹配）',
        contractNacSection: '约号与NAC（双向绑定）',
        nac: 'NAC',
        feeStatus: '状态',
        feeStatusAutoCalc: '根据有效期及启用状态自动判断',
        priority: '优先级',
        priorityTooltip: '数值越大优先执行',

        // 状态枚举
        statusEnum: {
          enabled: '启用',
          disabled: '禁用',
          expired: '失效'
        },

        // 日期类型选项
        dateTypeOptions: {
          flightDate: '航班日期（适用FSC等）',
          billDate: '制单日期（适用AWC等）'
        },

        // IATA分区选项
        iataZoneOptions: {
          tc1: 'TC1 - 美洲',
          tc2: 'TC2 - 欧非',
          tc3: 'TC3 - 亚太'
        },

        // 费用类型选项
        feeCategoryOptions: {
          origin: '起飞地费用',
          dest: '目的地费用',
          mainline: '干线附加费'
        },

        // 收费方式选项
        chargeMethodOptions: {
          byBl: '按票',
          byChargeWeight: '计重(/KG)',
          byActualWeight: '实重(/KG)'
        },

        // 付费条款选项
        paymentTermsOptions: {
          prepaid: '预付',
          collect: '到付'
        },

        // 占位符
        placeholders: {
          matchAll: '不填则匹配所有',
          unitRate: '单价',
          minCharge: '最低收费',
          maxCharge: '最高收费',
          remarks: '备注',
          enterPriority: '请输入优先级'
        },

        // 表格列
        tableColumns: {
          chargeName: '费用名称',
          chargeNameEn: '英文名',
          feeCategory: '费用类型',
          paymentTerms: '付费条款',
          currency: '币种',
          chargeMethod: '收费方式',
          unitRate: '单价',
          minCharge: '最低收费',
          maxCharge: '最高收费',
          includeInTotal: '计入总价',
          alreadyIncluded: '总价已包含',
          remarks: '备注',
          actions: '操作'
        },

        // 操作按鈕
        buttons: {
          back: '返回',
          save: '保存',
          edit: '编辑',
          copy: '复制'
        },

        // 消息提示
        messages: {
          copiedSuccess: '已复制到表单，保存后生效',
          loadFailed: '加载数据失败',
          copyLoadFailed: '复制数据加载失败',
          fillRequiredFields: '请补充基本信息中必填的项',
          fillChargeName: '请输入第 {row} 行的费用名称',
          fillFeeCategory: '请输入第 {row} 行的费用类型',
          fillPaymentTerms: '请输入第 {row} 行的付费条款',
          fillCurrency: '请输入第 {row} 行的币种',
          fillChargeMethod: '请输入第 {row} 行的收费方式',
          fillUnitRate: '请输入第 {row} 行的单价',
          updateSuccess: '修改成功',
          saveSuccess: '保存成功',
          saveFailed: '保存失败',
          atLeastOneFeeItem: '必须保留至少一条费用明细',
          countSuffix: '条',
          conflictTitle: '有效期冲突',
          conflictTip: '当前附加费与 {feeNos} 的有效期存在冲突，是否确认覆盖保存？',
          confirmOverride: '确认覆盖'
        },

        // 验证
        validation: {
          dateTypeRequired: '请选择日期类型'
        }
      },

      import: {
        title: '导入空运附加费',
        templateSection: '模板下载',
        templateDesc: '请先下载标准导入模板，按模板格式填写数据后上传',
        templateFile: '空运附加费导入模板.xlsx',
        uploadSection: '文件上传',
        dragText: '拖拽文件到此处，或点击上传',
        dragHint: '支持 .xlsx / .xls 格式，最大 5MB',
        remove: '移除',
        autoFillTitle: '自动填充说明',
        autoFillOffice: '所属公司：导入时自动获取您的所属公司',
        autoFillCode: '编码：系统自动生成（格式：AIR-YYYYNNNN）',
        autoFillStatus: '状态：导入后根据有效期自动判断（当前日期 ≤ 有效期截止 → 启用；否则 → 失效）',
        autoFillChargeMethod: '收费方式：计重/实重/按票',
        autoFillCountTotal: '是否计入总价：默认为「否」',
        autoFillTotalIncluded: '总价是否已包含：默认为「否」',
        fieldTitle: '字段说明',
        fieldOptional: '航空公司/起运国/起运城市/起运机场/目的国/目的城市/目的机场/供应商/约号/NAC：选填，支持多个（用分号分隔），不填则匹配所有',
        fieldNacNote: '约号与NAC：双向绑定，建议只填其中一个',
        fieldLinkage: '起运国/城市/机场、目的国/城市/机场：互相筛选联动',
        fieldDateRequired: '日期类型/有效期：必填',
        fieldFeeRequired: '费用名称/费用类型/付费条款/币种/收费方式/单价/是否计入总价/总价是否已包含：必填',
        cancel: '取消',
        startValidate: '开始校验',
        validating: '校验中...',
        validatePass: '校验通过',
        validatePassDesc: '共解析 {success} 条附加费记录，包含 {detail} 条费用明细',
        previewTitle: '数据预览（前 10 条）',
        validateFail: '校验完成，发现 {fail} 条错误',
        validateFailDesc: '成功：{success} 条  |  失败：{fail} 条',
        errorTitle: '失败明细',
        downloadError: '下载错误报告',
        successPreviewTitle: '成功数据预览（{count} 条）',
        colAirline: '航空公司',
        colPolAirport: '起运机场',
        colPodAirport: '目的机场',
        colIataZone: 'IATA分区',
        colContractNo: '约号',
        colFeeCount: '费用项',
        colFeeCountSuffix: '项',
        colValidity: '有效期',
        colRowNo: '行号',
        colFieldName: '错误字段',
        colErrorMsg: '错误原因',
        back: '返回修改',
        confirmImport: '确认导入（{count} 条）',
        importing: '正在导入...',
        importedProgress: '已处理：{processed} / {total} 条',
        importSuccess: '导入成功',
        importSuccessDesc: '成功导入 {success} 条附加费记录，包含 {detail} 条费用明细',
        importPartial: '导入完成，部分成功',
        importPartialDesc: '成功导入 {success} 条，失败 {fail} 条',
        importPartialHint: '失败原因已导出至错误报告，可修正后重新导入',
        confirm: '确定',
        fileSizeError: '文件大小不能超过 5MB',
        fileTypeError: '请上传 Excel 文件（.xlsx 或 .xls）',
        uploadSuccess: '上传成功，解析任务已提交',
        uploadFailed: '上传失败，请重试',
        downloadSuccess: '模板下载成功',
        generatingReport: '正在生成错误报告 Excel...'
      }
    },

    prePort: {
      import: {
        title: '导入港前附加费',
        templateSection: '模板下载',
        templateDesc: '请先下载标准导入模板，按模板格式填写数据后上传',
        downloadTemplate: '港前附加费导入模板.xlsx',
        uploadSection: '文件上传',
        dragText: '拖拽文件到此处，或点击上传',
        dragHint: '支持 .xlsx / .xls 格式，最大 5MB',
        remove: '移除',
        autoFillTitle: '自动填充说明',
        autoFillOffice: '所属公司：导入时自动获取您的所属公司',
        autoFillStatus: '状态：导入后根据有效期自动判断（当前日期 ≤ 有效期截止 → 启用；否则 → 失效）',
        autoFillUnit: '费用单位：支持 箱、票、天、次、重量(KGS)、立方米(CBM)、吨(TEN)、计费吨(RT)',
        autoFillBoxPrice: '箱型价格：单位为「箱」时，任一箱型存在价格即可',
        autoFillUnitPrice: '单价：单位非「箱」时必填',
        autoFillInTotal: '是否计入总价：默认为「否」',
        autoFillIncluded: '总价是否已包含：默认为「否」',
        cancel: '取消',
        startValidate: '开始校验',
        validating: '校验中...',
        fileSizeError: '文件大小不能超过 5MB',
        fileTypeError: '请上传 Excel 文件（.xlsx 或 .xls）',
        uploadSuccess: '上传成功，解析任务已提交',
        uploadFailed: '上传失败，请重试',
        downloadSuccess: '模板下载成功',
        downloadFailed: '下载模板失败'
      },
      columns: {
        rateType: '运价类型',
        feederType: '支线类型',
        railSeaType: '海铁类型',
        pol: '起运港',
        polTerminal: '起运港码头',
        supplier: '供应商',
        airPort: '起运机场',
        priority: '优先级'
      },
      configName: '港前附加费',
      actions: {
        add: '新增港前附加费',
        import: '导入',
        batchEnable: '批量启用 ({count})',
        batchDisable: '批量禁用 ({count})',
        view: '详情',
        edit: '编辑',
        more: '更多',
        copy: '复制',
        enable: '启用',
        disable: '禁用',
        delete: '删除'
      },
      messages: {
        deleteTitle: '确认删除',
        deleteContent: '确定要删除该记录吗？删除后不可恢复。',
        deleteOkText: '确认删除',
        disableContent: '确定要禁用该记录吗？',
        enableContent: '确定要启用该记录吗？',
        batchEnableTitle: '批量启用',
        batchEnableContent: '确定要启用选中的 {count} 条记录吗？',
        batchDisableTitle: '批量禁用',
        batchDisableContent: '确定要禁用选中的 {count} 条记录吗？',
        enableSuccess: '启用成功',
        enableFailed: '启用失败',
        disableSuccess: '禁用成功',
        disableFailed: '禁用失败',
        deleteSuccess: '删除成功',
        deleteFailed: '删除失败',
        batchEnableSuccess: '成功启用 {count} 条记录',
        batchEnableFailed: '批量启用失败',
        batchDisableSuccess: '成功禁用 {count} 条记录',
        batchDisableFailed: '批量禁用失败',
        dateRangeTo: '至 {date}',
        dateRangeFrom: '{date} 起'
      },
      detail: {
        createTitle: '新增港前附加费',
        editTitle: '编辑港前附加费',
        viewTitle: '港前附加费详情',
        copyTitle: '复制港前附加费',
        copyModeAlert: '复制模式：已复制原附加费数据，编号将在保存后自动生成。',
        basicInfo: '基础信息',
        feeNo: '附加费编号',
        rateType: '运价类型',
        feederType: '支线类型',
        railSeaType: '海铁类型',
        pol: '起运港',
        polTerminal: '起运港码头',
        supplier: '供应商',
        cargoType: '货物类型',
        airPort: '起运机场',
        office: '所属公司',
        priority: '优先级',
        priorityTooltip: '数值越大优先执行',
        validPeriod: '有效期',
        originRegion: '起运地区域',
        regionTip1: '起运地区域用于匹配货物提货地址，支持省/市/区/街道/社区多级选择。',
        regionTip2: '若不填写，则对所有区域生效；填写越精确，匹配优先级越高。',
        originLabel: '起运地址 {n}',
        noRegionSelected: '未选择区域',
        province: '省',
        city: '市',
        district: '区/县',
        township: '镇/街道',
        community: '社区',
        administrativeDivision: '行政区划',
        detailLocation: '详细地点',
        detailAddress: '详细地址',
        addOriginAddress: '添加起运地址',
        feeDetails: '费用明细',
        containerTypeSettings: '箱型设置',
        addFeeItem: '费用项目',
        selectBoxTypeTip: '请选择需要显示的箱型：',
        delete: '删除',
        yes: '是',
        no: '否',
        buttons: {
          back: '返回',
          save: '保存',
          edit: '编辑',
          copy: '复制'
        },
        placeholders: {
          feeNoGenerated: '保存后自动生成',
          feeNoAuto: '自动生成',
          select: '请选择',
          enterPriority: '请输入优先级',
          beginDate: '开始日期',
          endDate: '结束日期',
          selectProvince: '请选择省',
          selectCity: '请选择市',
          selectDistrict: '请选择区/县',
          selectTownship: '请选择镇/街道',
          selectCommunity: '请选择社区',
          enterDetailAddress: '请输入详细地址点击回车',
          selectFeeItem: '请选择费用名称',
          enterUnitPrice: '请输入单价',
          enterUnitRate: '请输入费用(票)',
          enterRemarks: '请输入备注',
          enterInput: '请输入'
        },
        validation: {
          rateTypeRequired: '请选择运价类型',
          feederTypeRequired: '请选择支线类型',
          railSeaTypeRequired: '请选择海铁类型',
          officeIdsRequired: '请选择所属公司',
          provinceIdRequired: '请选择省',
          cityIdRequired: '请选择市'
        },
        tableColumns: {
          feeName: '费用名称',
          billingUnit: '计费单位',
          currency: '币种',
          unitPrice: '单价',
          unitRate: '费用(票)',
          paymentType: '付费条款',
          remarks: '备注',
          isTotalIncluded: '总价是否已包含',
          isCountTotal: '是否计入总价',
          actions: '操作'
        },
        messages: {
          pleaseFillRequired: '请完善必填项',
          feeNameRequired: '第{row}行费用名称不能为空',
          billingUnitRequired: '第{row}行计费单位不能为空',
          currencyRequired: '第{row}行币种不能为空',
          isTotalIncludedRequired: '第{row}行请选择总价是否已包含',
          isCountTotalRequired: '第{row}行请选择是否计入总价',
          conflictTitle: '数据冲突提示',
          conflictContent: '与以下附加费存在冲突：{feeNos}，是否继续保存？',
          confirmOverride: '确认覆盖',
          cancel: '取消',
          saveSuccess: '保存成功',
          saveFailed: '保存失败'
        }
      }
    },

    express: {
      configName: '快递附加费',
      actions: {
        add: '新增快递附加费',
        batchEnable: '批量启用 ({count})',
        batchDisable: '批量禁用 ({count})',
        view: '详情',
        edit: '编辑',
        more: '更多',
        copy: '复制',
        enable: '启用',
        disable: '禁用',
        delete: '删除',
        addFeeItem: '添加费用项'
      },
      changeHistory: {
        title: '变更历史',
        titleWithCode: '{code} 变更记录',
        dateCreated: '变更时间',
        createdBy: '操作人',
        operationType: '操作类型',
        changedField: '字段',
        oldValue: '变更前',
        newValue: '变更后',
        allOperationTypes: '全部操作类型',
        operatorFilter: '按操作人筛选',
        empty: '暂无变更记录',
        recordMeta: '附加费类型：{type} · 编码：{code}',
        expandChanges: '展开查看变更字段',
        collapseChanges: '收起变更字段',
        beginDate: '有效期开始',
        endDate: '有效期截止',
        originDistrict: '发货区/县',
        originDetailAddress: '发货详细地址',
        destDistrict: '收货区/县',
        destDetailAddress: '收货详细地址',
        feeItems: '费用项',
        feeItemChange: '费用项变更：{name}',
        feeItemChangePrefix: '费用项变更：',
        feeItemFieldChange: '费用项 {name} · {field}',
        operations: {
          create: '新建',
          update: '编辑',
          delete: '删除',
          statusChange: '状态变更',
          enable: '启用',
          disable: '禁用'
        },
        status: {
          enabled: '启用',
          disabled: '禁用',
          expired: '已过期'
        }
      },
      columns: {
        feeNo: '附加费编码',
        route: '路线'
      },
      sections: {
        basicInfo: '基础信息',
        routeInfo: '路线信息',
        feeDetails: '费用明细'
      },
      fields: {
        feeNo: '附加费编号',
        priority: '优先级',
        priorityTip: '数值越大优先匹配，默认 50',
        unlimited: '不限制',
        supplier: '快递公司',
        accountNo: '账号',
        serviceType: '服务类型',
        officeIds: '所属公司',
        logisticsSupplierIds: '供应商',
        contractNos: '约号',
        cargoTypes: '货物类型',
        validPeriod: '有效期',
        feeStatus: '状态',
        origin: '发货地',
        destination: '目的地',
        originRoute: '发货地',
        destRoute: '收货地',
        originCountry: '发货国家',
        originProvince: '发货省/州',
        originCity: '发货市',
        destCountry: '收货国家',
        destProvince: '收货省/州',
        destCity: '收货市',
        country: '国家',
        province: '省/州',
        city: '城市',
        district: '区/县',
        detailAddress: '详细地址',
        firstWeightThreshold: '首重阈值',
        firstWeightPrice: '首重价格',
        additionalWeightUnit: '续重单位',
        additionalWeightPrice: '续重价格',
        unitPrice: '单价',
        fixedAmount: '固定金额',
        minCharge: '最低收费'
      },
      billingMode: {
        firstAdditional: '首重+续重',
        unitPrice: '单价计费',
        fixed: '固定费用',
        percentage: '百分比'
      },
      tableColumns: {
        chargeItem: '费用名称',
        billingMode: '计费模式',
        billingParams: '计费参数',
        measure: '单位',
        currency: '币种',
        minCharge: '最低收费',
        paymentType: '付费条款',
        includeInTotal: '是否计入总价',
        alreadyIncluded: '已包含',
        remarks: '备注',
        actions: '操作'
      },
      enums: {
        boolean: {
          yes: '是',
          no: '否'
        }
      },
      placeholders: {
        feeNoGenerated: '保存后自动生成',
        priority: '请输入 1-99',
        supplier: '请选择快递公司',
        accountNo: '请选择或输入账号',
        serviceType: '请选择服务类型',
        officeIds: '请选择所属公司',
        matchAll: '不填则匹配全部',
        beginDate: '开始日期',
        endDate: '结束日期',
        detailAddress: '请输入详细地址',
        chargeItem: '请选择费用名称',
        billingMode: '请选择计费模式',
        measure: '请选择单位',
        currency: '请选择币种',
        paymentType: '请选择付费条款',
        remarks: '请输入备注'
      },
      validation: {
        priorityRequired: '请输入优先级',
        priorityRange: '优先级范围为 1-99',
        matchFieldRequired: '请填写{field}，或勾选“不限制”',
        officeIdsRequired: '请选择所属公司',
        unsupportedServiceType: '当前服务类型不属于所选快递公司',
        chargeItemRequired: '第 {row} 行费用名称不能为空',
        billingModeRequired: '第 {row} 行请选择计费模式',
        measureRequired: '第 {row} 行请选择单位',
        currencyRequired: '第 {row} 行请选择币种',
        paymentTypeRequired: '第 {row} 行请选择付费条款',
        firstAdditionalRequired: '第 {row} 行请完整填写首重和续重参数',
        unitPriceRequired: '第 {row} 行请填写单价、固定金额或百分比',
        percentageInvalid: '第 {row} 行只有燃油附加费可使用 0-100 的百分比计费'
      },
      messages: {
        loadDataFailed: '加载数据失败',
        missingRecordId: '缺少记录 ID',
        deleteTitle: '确认删除',
        deleteContent: '确定要删除该记录吗？删除后不可恢复。',
        deleteOkText: '确认删除',
        deleteSuccess: '删除成功',
        deleteFailed: '删除失败',
        disableContent: '确定要禁用该记录吗？',
        enableContent: '确定要启用该记录吗？',
        enableSuccess: '启用成功',
        enableFailed: '启用失败',
        disableSuccess: '禁用成功',
        disableFailed: '禁用失败',
        batchEnableTitle: '批量启用',
        batchEnableContent: '确定要启用选中的 {count} 条记录吗？',
        batchDisableTitle: '批量禁用',
        batchDisableContent: '确定要禁用选中的 {count} 条记录吗？',
        batchEnableSuccess: '成功启用 {count} 条记录',
        batchEnableFailed: '批量启用失败',
        batchDisableSuccess: '成功禁用 {count} 条记录',
        batchDisableFailed: '批量禁用失败',
        matchAll: '全部',
        dateRangeTo: '至 {date}',
        dateRangeFrom: '{date} 起',
        atLeastOneFeeItem: '至少需要保留一条费用明细',
        pleaseFillRequired: '请完善必填项',
        conflictTitle: '数据冲突提示',
        conflictContent: '与以下附加费存在冲突：{feeNos}，请调整后再保存或启用。',
        updateSuccess: '修改成功',
        saveSuccess: '保存成功',
        saveFailed: '保存失败',
        copyDataFailed: '复制数据加载失败',
        loadChangeLogFailed: '加载变更历史失败',
        validityConflictTitle: '有效期冲突处理确认',
        validityConflictHint: '确认后将调整以下旧记录。禁用或截断会影响该记录的全部费用明细及适用范围，关闭开关不会自动恢复。',
        validityCurrentPeriod: '当前记录有效期：{period}',
        validityExistingPeriod: '已有记录有效期：{period}',
        validityDisable: '将禁用该条已有附加费，其余时段也将停止匹配。',
        validityTruncate: '将已有附加费的有效期截止日期调整至 {date}。',
        validityConfirm: '确认并处理',
        validityUnlimited: '不限',
        validityViewDetail: '查看详情',
        expiredEnableNotAllowed: '已过期的快递附加费不能启用，请先调整有效期'
      },
      detail: {
        createTitle: '新增快递附加费',
        editTitle: '编辑快递附加费',
        viewTitle: '快递附加费详情',
        copyTitle: '复制快递附加费',
        copyModeAlert: '复制模式：已复制原附加费数据，编号将在保存后自动生成。',
        buttons: {
          back: '返回',
          save: '保存',
          edit: '编辑',
          copy: '复制',
          changeHistory: '变更历史'
        }
      }
    },

    lastMile: {
      configName: '尾程附加费',
      actions: {
        add: '新增尾程附加费',
        import: '导入',
        batchEnable: '批量启用 ({count})',
        batchDisable: '批量禁用 ({count})',
        view: '详情',
        edit: '编辑',
        more: '更多',
        copy: '复制',
        enable: '启用',
        disable: '禁用',
        delete: '删除'
      },
      messages: {
        deleteTitle: '确认删除',
        deleteContent: '确定要删除该记录吗？删除后不可恢复。',
        deleteOkText: '确认删除',
        disableContent: '确定要禁用该记录吗？',
        enableContent: '确定要启用该记录吗？',
        batchEnableTitle: '批量启用',
        batchEnableContent: '确定要启用选中的 {count} 条记录吗？',
        batchDisableTitle: '批量禁用',
        batchDisableContent: '确定要禁用选中的 {count} 条记录吗？',
        enableSuccess: '启用成功',
        enableFailed: '启用失败',
        disableSuccess: '禁用成功',
        disableFailed: '禁用失败',
        deleteSuccess: '删除成功',
        deleteFailed: '删除失败',
        batchEnableSuccess: '成功启用 {count} 条记录',
        batchEnableFailed: '批量启用失败',
        batchDisableSuccess: '成功禁用 {count} 条记录',
        batchDisableFailed: '批量禁用失败',
        dateRangeTo: '至 {date}',
        dateRangeFrom: '{date} 起'
      },
      columns: {
        pods: '卸货港',
        podTerminalIds: '卸货港码头',
        supplierIds: '供应商',
        cargoTypes: '货物类型',
        officeIds: '所属公司',
        addressType: '地址类型',
        priority: '优先级'
      },
      detail: {
        createTitle: '新增尾程附加费',
        editTitle: '编辑尾程附加费',
        viewTitle: '尾程附加费详情',
        copyTitle: '复制尾程附加费',
        copyModeAlert: '复制模式：已复制原附加费数据，编号将在保存后自动生成。',
        basicInfo: '基础信息',
        feeNo: '附加费编号',
        pod: '卸货港',
        podTerminal: '卸货港码头',
        supplier: '供应商',
        cargoType: '货物类型',
        office: '所属公司',
        priority: '优先级',
        priorityTooltip: '数值越大优先执行，默认 1',
        validPeriod: '有效期',
        deliveryRegion: '配送地址区域',
        regionTip1: '按国家/省/市/区县级联选择配送区域，与尾程运价的配送地址区域精确匹配；可维护多组配送地址',
        regionTip2: '填写规则：国家/省/市仅支持选择 1 个；区/县、详细地址支持多选（用分号分隔），为空时匹配所有；若某级选择多个，则下级不可填写',
        deliveryAddressLabel: '配送地址 {n}',
        noRegionSelected: '未选择区域',
        addressType: '地址类型',
        warehouseCode: '仓库代码',
        easyWarehouseCode: '易仓代码',
        country: '国家',
        province: '省',
        city: '市',
        district: '区/县',
        postalCode: '邮编',
        detailAddress: '详细地址',
        addDeliveryAddress: '添加配送地址',
        feeDetails: '费用明细',
        containerTypeSettings: '箱型设置',
        addFeeItem: '费用项目',
        selectBoxTypeTip: '请选择需要显示的箱型：',
        delete: '删除',
        yes: '是',
        no: '否',
        buttons: {
          back: '返回',
          save: '保存',
          edit: '编辑',
          copy: '复制'
        },
        placeholders: {
          feeNoGenerated: '保存后自动生成',
          feeNoAuto: '自动生成',
          select: '请选择',
          enterPriority: '请输入优先级',
          beginDate: '开始日期',
          endDate: '结束日期',
          selectCountry: '请选择国家',
          selectProvince: '请选择省',
          selectCity: '请选择市',
          enterDistrict: '请输入区/县',
          enterPostalCode: '请输入邮编',
          enterDetailAddress: '请输入详细地址点击回车',
          selectAmazonWarehouse: '请选择亚马逊仓库',
          selectEasyWarehouse: '请选择易仓',
          selectFeeItem: '请选择费用名称',
          enterUnitPrice: '请输入单价',
          enterUnitRate: '请输入费用(票)',
          enterRemarks: '请输入备注',
          enterInput: '请输入'
        },
        validation: {
          podRequired: '请选择卸货港',
          officeIdsRequired: '请选择所属公司',
          countryIdRequired: '请选择国家',
          provinceIdRequired: '请选择省',
          cityIdRequired: '请选择市'
        },
        tableColumns: {
          feeName: '费用名称',
          billingUnit: '计费单位',
          currency: '币种',
          unitPrice: '单价',
          unitRate: '费用(票)',
          paymentType: '付费条款',
          remarks: '备注',
          isTotalIncluded: '总价是否已包含',
          isCountTotal: '是否计入总价',
          actions: '操作'
        },
        messages: {
          pleaseFillRequired: '请完善必填项',
          feeNameRequired: '第{row}行费用名称不能为空',
          billingUnitRequired: '第{row}行计费单位不能为空',
          currencyRequired: '第{row}行币种不能为空',
          isTotalIncludedRequired: '第{row}行请选择总价是否已包含',
          isCountTotalRequired: '第{row}行请选择是否计入总价',
          conflictTitle: '数据冲突提示',
          conflictContent: '与以下附加费存在冲突：{feeNos}，是否继续保存？',
          confirmOverride: '确认覆盖',
          cancel: '取消',
          saveSuccess: '保存成功',
          saveFailed: '保存失败'
        }
      },

      import: {
        title: '导入尾程附加费',
        templateSection: '模板下载',
        templateDesc: '请先下载标准导入模板，按模板格式填写数据后上传',
        downloadTemplate: '尾程附加费导入模板.xlsx',
        uploadSection: '文件上传',
        dragText: '拖拽文件到此处，或点击上传',
        dragHint: '支持 .xlsx / .xls 格式，最大 5MB',
        remove: '移除',
        autoFillTitle: '自动填充说明',
        autoFillOffice: '所属公司：导入时自动获取您的所属公司',
        autoFillStatus: '状态：导入后根据有效期自动判断（当前日期 ≤ 有效期截止 → 启用；否则 → 失效）',
        autoFillUnit: '费用单位：支持 箱、票、天、次、重量(KGS)、立方米(CBM)、吨(TEN)、计费吨(RT)',
        autoFillBoxPrice: '箱型价格：单位为「箱」时，任一箱型存在价格即可',
        autoFillUnitPrice: '单价：单位非「箱」时必填',
        autoFillInTotal: '是否计入总价：默认为「否」',
        autoFillIncluded: '总价是否已包含：默认为「否」',
        cancel: '取消',
        startValidate: '开始校验',
        validating: '校验中...',
        fileSizeError: '文件大小不能超过 5MB',
        fileTypeError: '请上传 Excel 文件（.xlsx 或 .xls）',
        uploadSuccess: '上传成功，解析任务已提交',
        uploadFailed: '上传失败，请重试',
        downloadSuccess: '模板下载成功',
        downloadFailed: '下载模板失败'
      }
    }
  }
}
